module.exports = __webpack_public_path__ + "img/sacred-heart.ab6a6b6a.jpg";